import React from 'react';
import constants from 'src/constants';
import { lang, upperFirstCharAll } from 'src/helpers';
import { MCButton } from '../basic';
import moment from 'moment';

export const appointmentStatusLabel = (appointment) => {
  if (appointment.data.status === constants.general.appointmentStatus.upcoming) {
    if (moment(appointment.data.startDate).isBefore(moment(), 'day')) {
      return 'pending';
    }
  }

  return appointment.data.status;
};

const AppointmentStatus = ({ appointment, ...props }) => {
  const status = appointmentStatusLabel(appointment);

  let attributes = { light: true, radius: true };

  switch (status) {
    case constants.general.appointmentStatus.upcoming:
      attributes.primary = true;
      break;
    case constants.general.appointmentStatus.attended:
      attributes.senary = true;
      break;
    case 'pending':
      attributes.septenary = true;
      break;
    default:
      attributes.quaternary = true;
      break;
  }

  return (
    <MCButton {...attributes} {...props}>
      {lang.t(upperFirstCharAll(status.split('_').join(' ')))}
    </MCButton>
  );
};

export default AppointmentStatus;
